import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/payme.png'
import _imports_1 from '@/assets/fps.png'
import _imports_2 from '@/assets/bank.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://crystalputeri.com/payme",
    target: "_blank"
  }, "crystalputeri.com/payme")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "(+852) 5222 2989", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("複製")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "(004) 747-231330-001", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "MALL LOL PET LIMITED", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "匯豐 HSBC", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("複製")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("付款後請透過 WhatsApp 將")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "付款證明", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("連同訂單編號發送至 ")
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, { fixed: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_list, { class: "normal-text" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list_header, { color: "primary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('CheckoutPage.paymentInfo')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.copyText('52222989')))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.copyText('747231330001')))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("a", {
                      target: "_blank",
                      href: $setup.getWhatsAppLink($props.orderCode)
                    }, "52222989", 8, _hoisted_14)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}